import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase'; // Importamos desde nuestro archivo centralizado
import { InputField } from './SharedComponents'; // Importamos componentes compartidos

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        try {
            await signInWithEmailAndPassword(auth, email, password);
        } catch (err) {
            setError('Error: Credenciales incorrectas o el usuario no existe.');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="w-full max-w-md p-8 space-y-8 bg-white rounded-lg shadow-md">
                <div className="text-center">
                    <h2 className="text-3xl font-bold text-gray-800">Control de Multas</h2>
                    <p className="mt-2 text-gray-600">Iniciar Sesión</p>
                </div>
                <form onSubmit={handleLogin} className="space-y-6">
                    {error && <p className="text-red-500 text-sm text-center">{error}</p>}
                    <InputField type="email" label="Correo Electrónico" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    <InputField type="password" label="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    <div>
                        <button type="submit" disabled={isLoading} className="w-full px-4 py-3 font-semibold text-white transition-colors duration-300 bg-blue-600 rounded-md hover:bg-blue-700 disabled:bg-blue-400">
                            {isLoading ? 'Ingresando...' : 'Ingresar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;